/* Waco Diamonds — collection card selection label.
   When a shopper narrows by Metal Karat / Carat Size / Diamond Quality (our filter groups) and/or
   picks a card's Metal Color swatch, show that configuration under the card's price — e.g.
   "Rose Gold · 1 ct · 10K · Better (E / VVS2)" — so the repriced "From $X" / exact price is clearly
   tied to what they selected (clarity + conversion). Reads the injected filter radios + each card's
   active swatch; presentation-only. No label until a karat/carat/quality is chosen, so cards look
   normal by default. */
(function () {
  "use strict";
  if (window.__wacoCardConfig) return;
  window.__wacoCardConfig = true;

  function selVal(dim) {
    var r = document.querySelector('input[data-waco-radio][data-waco-dim="' + dim + '"]:checked');
    return r && r.value ? r.value : null;
  }
  function cardColor(card) {
    var s = card.querySelector("[data-waco-card-swatch].is-active");
    return s ? (s.getAttribute("aria-label") || s.getAttribute("title") || null) : null;
  }
  function labelFor(card) {
    var k = selVal("k"), c = selVal("c"), q = selVal("q");
    if (!k && !c && !q) return ""; // no filter selection → keep the card's default look
    var parts = [];
    var col = cardColor(card);
    if (col) parts.push(col);
    if (k) parts.push(k);
    if (c) parts.push(c + " ct");
    if (q) parts.push(q);
    return parts.join(" · ");
  }
  function render(card) {
    var priceEl = card.querySelector(".card-product-content__price");
    if (!priceEl) return;
    var txt = labelFor(card);
    var el = card.querySelector(".waco-card-config");
    if (!txt) { if (el) el.hidden = true; return; }
    if (!el) {
      el = document.createElement("div");
      el.className = "waco-card-config card__interactive";
      priceEl.parentNode.insertBefore(el, priceEl.nextSibling);
    }
    el.hidden = false;
    el.textContent = txt;
  }
  function renderAll() {
    document.querySelectorAll(".card-product[data-waco-price-matrix]").forEach(render);
  }

  function init() {
    var style = document.createElement("style");
    style.textContent =
      ".waco-card-config{font-size:.8125rem;line-height:1.3;letter-spacing:.01em;opacity:.7;margin-top:.25rem;text-transform:none;}";
    document.head.appendChild(style);

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; renderAll(); });
    }
    // filter-group changes
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (t && t.matches && t.matches("input[data-waco-radio]")) schedule();
    });
    // swatch colour changes (capture, then re-render next frame after is-active is applied)
    document.addEventListener("click", function (e) {
      if (e.target && e.target.closest && e.target.closest("[data-waco-card-swatch]")) schedule();
    }, true);
    // facet AJAX re-renders replace cards
    if (window.MutationObserver) {
      var obs = new MutationObserver(schedule);
      obs.observe(document.body, { childList: true, subtree: true });
    }
    schedule();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
